import { KeenSliderHooks, KeenSliderInstance, useKeenSlider } from 'keen-slider/react';
import React, { MutableRefObject, PropsWithChildren } from 'react';
import { CarouselOptions } from './types';
import { ThumbnailPlugin } from './utils';
interface Props extends PropsWithChildren {
  sliderInstanceRef: MutableRefObject<KeenSliderInstance<object, object, KeenSliderHooks> | null>;
  thumbnailOptions?: CarouselOptions;
}
const ThumbnailCarousel = ({
  sliderInstanceRef,
  thumbnailOptions,
  children
}: Props) => {
  const [thumbnailRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    mode: thumbnailOptions?.mode || 'snap',
    slides: {
      perView: thumbnailOptions?.perView || 4,
      spacing: thumbnailOptions?.spacing || 8
    }
  }, [ThumbnailPlugin(sliderInstanceRef)]);
  return <div ref={thumbnailRef} className='keen-slider thumbnail' data-sentry-component="ThumbnailCarousel" data-sentry-source-file="thumbnail-carousel.tsx">
            {children}
        </div>;
};
export default ThumbnailCarousel;